module.exports = __webpack_public_path__ + "static/media/memories-Logo.8e9763ff.png";